/**
 * StudentAssessmentsScreen — « Mes contrôles » de l'élève (route `school-assessments`), à la place de
 * `student/schoolAssessments/SchoolAssessmentsScreen.js` quand l'espace élève est allumé.
 *
 * Un fil : la lecture (`useStudentAssessmentsData`), le view-model, la feuille d'ajout et de
 * modification (`useStudentAssessmentForm`), les gestes de la liste (`useStudentAssessmentsState`)
 * → `<StudentAssessmentsPage>`. Les paramètres de route `studentId` / `student` sont ceux du tuteur
 * (`NextAssessmentWidget` dans sa fiche élève) : un tuteur ne voit jamais cet écran, l'élève lit
 * toujours ses propres contrôles.
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentAssessmentsPage } from "../../../../../../design-system/student"
import { studentAssessmentsViewModel } from "../../../../view-models/student/Assessments/studentAssessmentsViewModel"
import { useStudentAssessmentForm } from "./useStudentAssessmentForm"
import { useStudentAssessmentsData } from "./useStudentAssessmentsData"
import { useStudentAssessmentsState } from "./useStudentAssessmentsState"

export function StudentAssessmentsScreen() {
    const vm = useSelector(studentAssessmentsViewModel)
    const { refresh } = useStudentAssessmentsData(vm.studentId)
    const { assessmentForm, openAdd, openEdit } = useStudentAssessmentForm({
        studentId: vm.studentId,
        studentClass: vm.studentClass,
        subjects: vm.subjects,
        edits: vm.edits,
    })
    const state = useStudentAssessmentsState({ onEdit: openEdit })

    return (
        <StudentAssessmentsPage
            assessments={vm.assessments}
            loading={vm.loading}
            error={vm.error}
            onRetry={refresh}
            onAddAssessment={openAdd}
            assessmentForm={assessmentForm}
            {...state}
        />
    )
}
